export enum LeagueType {
  IRON,
  BRONZE,
  SILVER,
  GOLD,
  PLATINIUM,
  DIAMOND,
  MASTER
}

export enum LeagueName {
  "iron",
  "bronze",
  "silver",
  "gold",
  "platinium",
  "diamond",
  "master",
  "next"
}